import { useState, useRef } from "react";
import cx from "classnames";

import { Icon } from "common/ui/Icon";
import { ActionList } from "common/ui/ActionList";
import { Button } from "common/ui/Button";
import { Stack } from "common/ui/Stack";

import { useClickOutside } from "common/middleware/hooks";

import styles from "./ButtonWithOptions.module.scss";

interface Props {
  variant?: "primary" | "secondary";
  primaryAction: {
    title: string,
    onClick: () => void,
    disabled?: boolean,
  }
  actions?: {
    name: string | number,
    disabled?: boolean,
    onClick: () => void,
  }[],
  disabled?: boolean,
  alignTop?: boolean
}

export function ButtonWithOptions({
  variant = "primary",
  primaryAction,
  actions,
  disabled,
  alignTop = false
}: Props) {
  const [showActions, setShowActions] = useState(false);

  const dropdown = useRef(null);
  useClickOutside(dropdown, () => setShowActions(false));

  return (
    <div className={styles.Container}>
      <Stack>
        <Button
          className={cx(styles.Button, {
            [styles.disabled]: disabled || primaryAction.disabled,
          })}
          variant={variant}
          onClick={primaryAction.onClick}
          disabled={disabled || primaryAction.disabled}
          fullWidth
        >
          {primaryAction.title}
        </Button>
        <Button
          className={cx(styles.Dropdown, {
            [styles.disabled]: disabled,
            [styles.secondary]: variant === "secondary",
          })}
          variant={variant}
          onClick={() => setShowActions(!showActions)}
          disabled={disabled}
        >
          <Icon icon="moreActionsMinor" />
        </Button>
      </Stack>
      <div
        ref={dropdown}
        className={cx(styles.List, {
          [styles.open]: showActions,
          [styles.alignTop]: alignTop
        })}
      >
        <ActionList
          menu={actions}
          close={() => setShowActions(false)}
        />
      </div>
    </div>
  )
}

